import React, { Component } from "react"

interface Step {
  title: string
  description: string
}

interface Props {
  steps: Step[]
  stepIndex: number
}

export default class Steps extends Component<Props> {
  renderStepStatus = (type: string) => {
    let content = null

    if (type === "done") {
      content = (
        <svg
          className="w-5 h-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clipRule="evenodd"
          />
        </svg>
      )
    } else if (type === "current") {
      content = <span className="h-2.5 w-2.5 bg-green-600 rounded-full"></span>
    } else {
      content = (
        <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
      )
    }

    let defaultClassName = ""
    if (type === "done") {
      defaultClassName =
        "relative z-10 w-8 h-8 flex items-center justify-center rounded-full bg-green-600"
    } else {
      defaultClassName =
        "relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-green-600 rounded-full"
    }

    return (
      <span className="h-9 flex items-center">
        <span className={defaultClassName}>{content}</span>
      </span>
    )
  }

  renderSteps = () => {
    const stepView: any = []
    const stepLength = this.props.steps.length

    this.props.steps.map((eachStep, index: number) => {
      let currentStatus = ""
      if (index === this.props.stepIndex) {
        currentStatus = "current"
      } else if (index < this.props.stepIndex) {
        currentStatus = "done"
      }

      stepView.push(
        <li className="relative pb-10" key={index}>
          {index + 1 < stepLength && (
            <div
              className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-green-600"
              aria-hidden="true"
            ></div>
          )}
          <div className="relative flex items-start group">
            {this.renderStepStatus(currentStatus)}
            <span className="ml-4 min-w-0 flex flex-col">
              <span className="text-xs font-semibold tracking-wide uppercase text-green-100">
                {eachStep.title}
              </span>
              <span className="text-sm text-green-100">
                {eachStep.description}
              </span>
            </span>
          </div>
        </li>
      )
      return null
    })

    return stepView
  }

  render() {
    return (
      <nav aria-label="Progress" className="mt-6">
        <ol className="overflow-hidden">{this.renderSteps()}</ol>
      </nav>
    )
  }
}
